<template>
  <div class="comments-im-pc" :style="contentStyle">
    <!-- <div class="tips">
      <svg-icon icon-class="trumpet" />
      <p>欢迎进入课堂，可在此向老师提问和交流，请勿讨论与课程无关内容</p>
    </div> -->
    <div class="scroll-list-wrap" :style="wrapStyle">
      <cube-scroll ref="commentScroll" :data="list">
        <div class="list" v-if="list.length > 0">
          <template v-for="item in list">
            <m-comment-item
              v-if="item.payload.data || item.payload.text"
              :key="item.ID"
              :comment="item"
            />
          </template>
        </div>
      </cube-scroll>
    </div>
    <div ref="apply" class="apply-pc" id="apply" v-if="isLogin">
      <input
        placeholder="快来提问吧"
        v-model="model.inputText"
        @focus="focusHandler"
        @blur="blurHandle"
      />
      <cube-button
        class="submit"
        style="height:40px;width:100px;padding: 4px 6px;"
        :primary="true"
        :inline="true"
        @click="submitHandle"
        :disabled="btnDisabled || disabledMessage"
        >发送</cube-button
      >
    </div>
  </div>
</template>

<script>
import { isMobile } from '@/utils/index.js';
import { mapGetters } from 'vuex';
import scrollMixin from '@/mixins/scroll';
import MCommentItem from '@/components/MCommentItemIM/IndexPC.vue';
import TIM from 'tim-js-sdk';
// import { parse } from 'path';
// 发送图片、文件等消息需要的 COS SDK
// import COS from 'cos-js-sdk-v5';

/**
 * 错误码
 * 80001:敏感词
 * 10010:群组不存在，或者曾经存在过，但是目前已经被解散
 * 10013:被邀请加入的用户已经是群成员
 * 10014:群已满员，无法将请求中的用户加入群组
 * 10015:群组 ID 非法，请检查群组 ID 是否填写正确
 */
export default {
  name: 'live-comments',
  components: {
    MCommentItem
  },
  props: {
    live: {
      type: Object,
      required: true,
      default: () => {}
    },
    contentHeight: {
      type: Number,
      required: false,
      default: () => {}
    },
    isLogin: {
      type: Boolean
    }
  },
  mixins: [scrollMixin],
  data() {
    return {
      messageType: {
        entry: 'ID_REMOTE_USER_JOIN',
        default: 'ID_REMOTE_USER_MSG',
        teacherEntry: 'ID_REMOTE_TEACHER_JOIN',
        teacherQuit: 'ID_LEAVE_CLASS',
        shutUp: 'ID_ALL_SHUTUP',
        ownEntry: 'ID_MYSELF_ENTRY',
        keepAlive: 'ID_KEEP_LIVE'
      },
      textareaPlaceholder: '快来提问吧...',
      list: [],
      model: {
        inputText: ''
      },
      btnDisabled: false,
      disabledMessage: false // 禁言状态
    };
  },
  computed: {
    ...mapGetters(['courseInfo', 'userInfo', 'lastUserInfo']),
    contentStyle() {
      return {
        height: 'calc(100vh - 1rem)'
      };
    },
    wrapStyle() {
      return {
        height: '90%'
      };
    }
  },
  mounted() {
    this.initChat();
    if (isMobile()) {
      document.body.addEventListener('focusout', () => {
        //软键盘关闭事件
        this.$nextTick(() => {
          this.blurHandle();
        });
      });
    }
    this.disabledMessage = this.courseInfo.sc_silent_status === '2';
  },
  watch: {
    live() {
      this.joinChat();
    }
  },
  methods: {
    initChat() {
      const user = JSON.parse(global.localStorage.getItem('userInfo'));
      let options = {
        SDKAppID: Number(user.appid) // 接入时需要将0替换为您的即时通信 IM 应用的 SDKAppID
      };
      // 创建 SDK 实例，TIM.create() 方法对于同一个 SDKAppID 只会返回同一份实例
      this.tim = TIM.create(options); // SDK 实例通常用 tim 表示

      // 设置 SDK 日志输出级别，详细分级请参见 setLogLevel 接口的说明
      // this.tim.setLogLevel(0); // 普通级别，日志量较多，接入时建议使用
      this.tim.setLogLevel(1); // release 级别，SDK 输出关键信息，生产环境时建议使用

      this.tim.on(TIM.EVENT.SDK_READY, this.onSdkReady);
      // 注册 COS SDK 插件
      // tim.registerPlugin({ 'cos-js-sdk': COS });
      this.listenChat();
      this.login();
    },
    onSdkReady() {
      console.log('onSdkReady===');
      // this.createChat();
    },
    login() {
      const user = JSON.parse(global.localStorage.getItem('userInfo'));
      let promise = this.tim.login({
        userID: user.identifier,
        userSig: user.imsign
      });
      const that = this;
      promise
        .then(function(imResponse) {
          console.log('登录成功 == ', imResponse.data); // 登录成功
          that.joinChat(true);
        })
        .catch(function(imError) {
          console.warn('login error:', imError); // 登录失败的相关信息
        });
    },
    logout() {
      let promise = this.tim.logout();
      promise
        .then(function(imResponse) {
          console.log('退出成功 ===', imResponse.data); // 登出成功
        })
        .catch(function(imError) {
          console.warn('logout error:', imError);
        });
    },
    listenChat() {
      const that = this;
      // 监听事件，例如：
      this.tim.on(TIM.EVENT.SDK_READY, function(event) {
        console.log('event:TIM.EVENT.SDK_READY ', event);
        // 收到离线消息和会话列表同步完毕通知，接入侧可以调用 sendMessage 等需要鉴权的接口
        // event.name - TIM.EVENT.SDK_READY
      });

      this.tim.on(TIM.EVENT.MESSAGE_RECEIVED, function(event) {
        // 收到推送的单聊、群聊、群提示、群系统通知的新消息，可通过遍历 event.data 获取消息列表数据并渲染到页面
        // event.name - TIM.EVENT.MESSAGE_RECEIVED
        // event.data - 存储 Message 对象的数组 - [Message]
        console.log('MESSAGE_RECEIVED ==== ', event.data);
        const messages = event.data;
        if (messages.length > 0) {
          for (let index = 0; index < messages.length; index++) {
            const item = messages[index];
            const msg = item.payload.text;
            if (msg) {
              const data = JSON.parse(msg);
              if (data.eventid === that.messageType.teacherEntry) {
                // 因为流的延迟问题，延后3秒播放视频
                setTimeout(() => {
                  that.$emit('changeTip', true);
                  that.$store.commit('SET_COURSE_INFO_STATUS');
                  that.list.push(item);
                }, 3000);
              } else if (data.eventid === that.messageType.teacherQuit) {
                // 老师下课
                that.$emit('changeTip', false);
                that.clearInterval();
              } else if (data.eventid === that.messageType.shutUp) {
                // 老师禁言
                that.disabledMessage = data.property.isStart;
                that.list.push(item);
              } else if (data.eventid === that.messageType.default) {
                if (data.property.msg && data.property.msg.length > 0) {
                  that.list.push(item);
                }
              }
              that.scrollToEnd();
            }
          }
        }
      });

      this.tim.on(TIM.EVENT.MESSAGE_REVOKED, function(event) {
        console.log('event: TIM.EVENT.MESSAGE_REVOKED', event);
        // 收到消息被撤回的通知
        // event.name - TIM.EVENT.MESSAGE_REVOKED
        // event.data - 存储 Message 对象的数组 - [Message] - 每个 Message 对象的 isRevoked 属性值为 true
      });

      this.tim.on(TIM.EVENT.CONVERSATION_LIST_UPDATED, function(event) {
        console.log('event: TIM.EVENT.CONVERSATION_LIST_UPDATED', event);
        // 收到会话列表更新通知，可通过遍历 event.data 获取会话列表数据并渲染到页面
        // event.name - TIM.EVENT.CONVERSATION_LIST_UPDATED
        // event.data - 存储 Conversation 对象的数组 - [Conversation]
      });

      this.tim.on(TIM.EVENT.GROUP_LIST_UPDATED, function(event) {
        console.log('event: TIM.EVENT.GROUP_LIST_UPDATED', event);
        // 收到群组列表更新通知，可通过遍历 event.data 获取群组列表数据并渲染到页面
        // event.name - TIM.EVENT.GROUP_LIST_UPDATED
        // event.data - 存储 Group 对象的数组 - [Group]
      });

      this.tim.on(TIM.EVENT.GROUP_SYSTEM_NOTICE_RECEIVED, function(event) {
        console.log('event: TIM.EVENT.GROUP_SYSTEM_NOTICE_RECEIVED', event);
        // 收到新的群系统通知
        // event.name - TIM.EVENT.GROUP_SYSTEM_NOTICE_RECEIVED
        // event.data.type - 群系统通知的类型，详情请参见 GroupSystemNoticePayload 的 operationType 枚举值说明
        // event.data.message - Message 对象，可将 event.data.message.content 渲染到到页面
      });

      this.tim.on(TIM.EVENT.PROFILE_UPDATED, function(event) {
        console.log('event:TIM.EVENT.PROFILE_UPDATED ', event);
        // 收到自己或好友的资料变更通知
        // event.name - TIM.EVENT.PROFILE_UPDATED
        // event.data - 存储 Profile 对象的数组 - [Profile]
      });

      this.tim.on(TIM.EVENT.BLACKLIST_UPDATED, function(event) {
        console.log('event:TIM.EVENT.BLACKLIST_UPDATED', event);
        // 收到黑名单列表更新通知
        // event.name - TIM.EVENT.BLACKLIST_UPDATED
        // event.data - 存储 userID 的数组 - [userID]
      });

      this.tim.on(TIM.EVENT.ERROR, function(event) {
        console.log('event: IM.EVENT.ERROR', event);
        // 收到 SDK 发生错误通知，可以获取错误码和错误信息
        // event.name - TIM.EVENT.ERROR
        // event.data.code - 错误码
        // event.data.message - 错误信息
      });

      this.tim.on(TIM.EVENT.SDK_NOT_READY, function(event) {
        console.log('event: TIM.EVENT.SDK_NOT_READY', event);
        // 收到 SDK 进入 not ready 状态通知，此时 SDK 无法正常工作
        // event.name - TIM.EVENT.SDK_NOT_READY
      });

      this.tim.on(TIM.EVENT.KICKED_OUT, function(event) {
        console.log('event: TIM.EVENT.KICKED_OUT', event);
        // 收到被踢下线通知
        // event.name - TIM.EVENT.KICKED_OUT
        // event.data.type - 被踢下线的原因，例如:
        //    - TIM.TYPES.KICKED_OUT_MULT_ACCOUNT 多实例登录被踢
        //    - TIM.TYPES.KICKED_OUT_MULT_DEVICE 多终端登录被踢
        //    - TIM.TYPES.KICKED_OUT_USERSIG_EXPIRED 签名过期被踢
        // const data = {
        //   code: event.code + '',
        //   message: JSON.stringify(event.data),
        //   desc: event.name
        // };
        // that.sendLog(data);
      });
    },
    createChat() {
      // 创建群
      let promise = this.tim.createGroup({
        type: TIM.TYPES.GRP_CHATROOM,
        name: '测试群组',
        groupID: this.courseInfo.sc_course_number
        // memberList: [{ userID: 'user1' }, { userID: 'user2' }] // 如果填写了 memberList，则必须填写 userID
      });
      promise
        .then(function(imResponse) {
          // 创建成功
          console.log('创建成功 == ', imResponse.data.group); // 创建的群的资料
        })
        .catch(function(imError) {
          console.warn('createGroup error:', imError); // 创建群组失败的相关信息
        });
    },
    // tryAgain: true 时失败后重试，不传 或为false 不重试
    joinChat(tryAgain) {
      const that = this;
      console.log('that.live: ', that.live);
      let promise = this.tim.joinGroup({
        groupID: String(that.live.liveId),
        type: TIM.TYPES.GRP_CHATROOM
      });
      promise
        .then(function(imResponse) {
          switch (imResponse.data.status) {
            case TIM.TYPES.JOIN_STATUS_WAIT_APPROVAL: // 等待管理员同意
              break;
            case TIM.TYPES.JOIN_STATUS_SUCCESS: // 加群成功
              console.log('加群成功 == ', imResponse.data.group); // 加入的群组资料
              that.sendWelcomeMessage();
              // that.heart();

              break;
            case TIM.TYPES.JOIN_STATUS_ALREADY_IN_GROUP: // 已经在群中
              console.log('已经在群中 == ');
              that.sendWelcomeMessage();
              // that.heart();
              break;
            default:
              break;
          }
        })
        .catch(function(imError) {
          console.log('joinGroup error:', imError); // 申请加群失败的相关信息
          const code = imError.code;
          // 被邀请加入的用户已经是群成员，即踢人情况，直接发送欢迎消息
          if (code === 10013) {
            that.sendWelcomeMessage();
            // that.heart();
            return;
          }

          if (tryAgain) {
            that.joinChat(false);
          }
        });
    },
    sendWelcomeMessage() {
      this.createMessage(this.messageType.entry, '', true);
    },
    quitChat() {
      const that = this;
      console.log('String(that.live.liveId): ', that.live, String(that.live.liveId));
      let promise = this.tim.quitGroup(String(that.live.liveId));
      promise
        .then(function(imResponse) {
          console.log('成功退出群组 === ', imResponse.data.groupID); // 退出成功的群 ID
          that.logout();
        })
        .catch(function(imError) {
          console.warn('quitGroup error:', imError); // 退出群组失败的相关信息
          //   const data = {
          //     code: imError.code + '',
          //     message: JSON.stringify(imError),
          //     desc: 'im 退出群组失败'
          //   };
          //   that.sendLog(data);
        });
    },
    /**
     * 创建消息并发送消息
     * type: 消息类型
     * msg: 消息内容
     * tryAgain: true 时失败后重试，不传 或为false 不重试
     */
    createMessage(type, msg, tryAgain) {
      // 发送文本消息，Web 端与小程序端相同
      // 1. 创建消息实例，接口返回的实例可以上屏
      // let message = this.tim.createCustomMessage({
      //   // to: this.courseInfo.sc_course_number,
      //   to: 'liveclass0207',
      //   conversationType: TIM.TYPES.CONV_GROUP,
      //   payload: {
      //     data: this.formatMessage(type, msg),
      //     description: Math.random(1, 6).toString(), // 获取骰子点数
      //     extension: ''
      //   }
      // });

      let message = this.tim.createTextMessage({
        to: String(this.live.liveId),
        conversationType: TIM.TYPES.CONV_GROUP,
        payload: {
          text: this.formatMessage(type, msg)
        }
      });

      // 2. 发送消息
      let promise = this.tim.sendMessage(message);
      if (!promise) {
        this.btnDisabled = false;
        return;
      }
      const that = this;
      promise
        .then(function(imResponse) {
          // 发送成功
          console.log('发送成功 === ', imResponse);
          if (type === that.messageType.default) {
            that.model.inputText = '';
            that.btnDisabled = false;
          }
          that.list.push(imResponse.data.message);
          console.log('that.list: ', that.list);

          that.scrollToEnd();
        })
        .catch(function(imError) {
          // 发送失败
          that.btnDisabled = false;

          const code = imError.code;
          // 欢迎消息时才重试
          if (type === that.messageType.entry) {
            if (code === 80001) {
              // 如果姓名带敏感词，返回上一页
              that.showToast('姓名中包含敏感字样，请重新填写姓名');
              setTimeout(() => {
                that.back();
              }, 2500);
              return;
            }

            if (tryAgain) {
              that.createMessage(type, msg, false);
            } else {
              that.showToast('您无法加入课堂讨论，请重新加入或者联系老师！');
            }
          }

          if (code === 80001) {
            that.showToast('请使用文明用语');
            that.model.inputText = '';
          }
          console.log('imError == ', imError);

          // const data = {
          //   code: code + '',
          //   message: JSON.stringify(imError),
          //   desc: 'im 发送消息失败'
          // };
          // that.sendLog(data);

          // const text = imTips[code];
          // if (text) {
          //   that.showToast(text);
          // }
        });
    },
    formatMessage(type, msg) {
      const user = JSON.parse(global.localStorage.getItem('userInfo'));
      const messageText = {
        eventid: type || this.messageType.default,
        property: {
          realname: user.realname,
          uid: this.userInfo.identifier
        }
      };

      if (type === this.messageType.default) {
        messageText.property.msg = msg;
      }

      return JSON.stringify(messageText);
    },
    focusHandler() {
      console.log(1111111);
      this.$emit('checkLogin');
      if (this.isiOS()) {
        this.$nextTick(() => {
          // 设置body的高度为可视高度+302
          // 302为原生键盘的高度
          document.getElementsByTagName('body')[0].style.height = window.innerHeight + 302 + 'px';
          document.body.scrollTop = 302;
        });
      }
    },
    isiOS() {
      const u = navigator.userAgent;
      const iOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      return iOS;
    },
    blurHandle() {
      if (this.isiOS()) {
        // 设置body恢复原来的高度
        document.getElementsByTagName('body')[0].style.height = window.innerHeight + 'px';
      }

      window.scroll(0, 0);
    },
    submitHandle() {
      if (this.model.inputText.trim() === '') {
        this.showToast('请填写提问内容');
        return;
      }
      this.btnDisabled = true;
      this.createMessage(this.messageType.default, this.model.inputText, false);
    },
    scrollToEnd() {
      // this.$nextTick(() => {
      //   const scroll = this.$refs.commentScroll;
      //   scroll && scroll.scrollTo(0, scroll.scroll.maxScrollY);
      // });
      setTimeout(() => {
        const scroll = this.$refs.commentScroll;
        scroll && scroll.scrollTo(0, scroll.scroll.maxScrollY);
      }, 200);
    },
    /**
     * 显示提示信息
     */
    showToast(msg) {
      this.$createToast({
        time: 3000,
        type: 'warn',
        txt: msg
      }).show();
    },
    back() {
      const time = new Date().getTime();
      this.$router.push({
        path: `/home?code=${this.$route.params.code}&time=${time}`
      });
    },
    // 心跳
    // heart() {
    //   const that = this;
    //   this.timer = setInterval(function() {
    //     console.log('heart =======');
    //     that.createMessage(this.messageType.keepAlive, '', false);
    //   }, 2 * 60 * 1000);
    // },
    clearInterval() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    },
    // sendLog(params) {
    //   const data = {
    //     ...params,
    //     url: 'liveclass/course/courseaction',
    //     parames: JSON.stringify({ name: this.userInfo.identifier }),
    //     course_number: this.courseInfo.sc_course_number
    //   };
    //   api.sendErrorLog(data);
    // },
    isWeixin() {
      //判断是否是微信
      var ua = navigator.userAgent.toLowerCase();
      return ua.match(/MicroMessenger/i) == 'micromessenger';
    }
  },
  destroyed() {
    this.clearInterval();
    this.quitChat();
  }
};
</script>

<style lang="less">
.comments-im-pc {
  width: 100%;
  position: relative;

  .scroll-list-wrap {
    text-align: left;
    background-color: #04182b;
    height: calc(100vh - 210px - 48px - 46px);

    .cube-scroll-list-wrapper {
      .cube-scroll-content {
        .cube-scroll-list-wrapper {
          min-height: unset !important;
        }
      }
    }

    .cube-form-item {
      border-top: 1px solid #ddd;
      background: #f5f5f9;
      padding: 0 10px;

      .cube-textarea-wrapper {
        border-radius: 15px;
        background-color: #fff;
        padding: 6px 0;

        textarea {
          padding: 0 15px;
        }

        &.cube-textarea_expanded {
          min-height: 20px;
        }
      }
    }
  }

  .apply-pc {
    display: flex;
    align-items: center;
    // bottom: 0;
    width: calc(100% - 8px);
    padding: 0 4px;
    height: 8px;
    z-index: 99;
    position: absolute;
    bottom: 5px;

    input {
      width: 100%;
      height: 8px;
      // margin: 6px 10px 6px 10px;
      padding: 1px 2px;
      border-radius: 18px;
      font-size: 4px;
      color: #3a6b99;
    }

    .cube-btn {
      border-radius: 8px;
      font-size: 4px;

      &:after {
        content: none;
      }
    }
  }
}
</style>
